// @flow
import type { Match, RouterHistory } from 'react-router-dom';

import * as React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import colors from '../../assets/css/colors';
// import Facebook from '../../components/Icons/Facebook';
// import Twitter from '../../components/Icons/Twitter';
import {
	// SocialLink,
	CountdownTimer,
	GameBarTimer,
	DraftNotifications,
} from '../';

import * as selectors from '../../modules/selectors';

const TopBarWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 70px;
	width: 100%;
	background-color: #FFFFFF;

	.social-block {
		border-radius: 50%;
		width: 25px;
		height: 25px;
	}
`;

const BarItem = styled.div`
	display: flex;
	height: 70px;
	align-items: center;
`;

const DraftTimerWrapper = styled.div`
	text-align: center;
	margin: 0 1.5em;

	p {
		margin-bottom: .5em;
		color: ${colors.nrlDarkGreenHover};
		font-size: 12px;
	}
`;

const TeamName = styled.h4`
	color: ${colors.nrlDarkGreen};
	margin-right: 1em;
`;

const UserAvatar = styled.img`
	width: 45px;
	border-radius: 50%;
	margin: 0 1.5em;
`;

const getUserAvatar = ({ avatar_version, id }) => {
	return process.env.REACT_APP_AVATARS_PATH + id + '.png?v=' + avatar_version;
};

type Props = {
	user: Object,
	league: Object,
	match: {
		...Match,
		params: {
			league_id: number
		}
	},
	selected_round: Object,
	history: RouterHistory,
	actual_round: Object
};

class TopBarComponent extends React.Component<Props> {
	constructor(props) {
		super(props);

		_.bindAll(this, 'onTimerComplete');
	}

	onTimerComplete() {
		const { match: { params: { league_id } }, history } = this.props;
		history.push(`/league/${league_id}/team/live-draft`);
	}

	get timer() {
		const { league, selected_round } = this.props;
		if (_.isEmpty(league) || _.isEmpty(selected_round)) {
			return null;
		}

		return <GameBarTimer selected_round={selected_round} league={league} />;
	}

	render() {
		const { user, league } = this.props;
		const { draft_status } = league;
		const is_draft_scheduled = draft_status === 'scheduled';

		return (
			<TopBarWrapper>
				<BarItem>
					<UserAvatar src={getUserAvatar(user)} />
					<TeamName className='hidden-mobile'>{user.team_name}</TeamName>
					{/*Commented due to following ticket:*/}
					{/*https://fanhub.atlassian.net/browse/NRLDRAFT-531*/}
					{/*<SocialLink*/}
					{/*target="_blank"*/}
					{/*aria-label="Follow"*/}
					{/*className="social-block"*/}
					{/*>*/}
					{/*<Facebook size="1.2" />*/}
					{/*</SocialLink>*/}
					{/*<SocialLink*/}
					{/*target="_blank"*/}
					{/*aria-label="Twitter"*/}
					{/*className="social-block"*/}
					{/*>*/}
					{/*<Twitter size="1.2" />*/}
					{/*</SocialLink>*/}
				</BarItem>
				<BarItem>
					{league.team_id ? (
						<DraftNotifications id={league.id} team_id={league.team_id} />
					) : null}

					{is_draft_scheduled ? (
						<BarItem>
							<DraftTimerWrapper>
								<p>DRAFT STARTS IN</p>
								<CountdownTimer
									date={league.draft_start}
									onComplete={this.onTimerComplete}
								/>
							</DraftTimerWrapper>
						</BarItem>
					) : this.timer}
				</BarItem>
			</TopBarWrapper>
		);
	}
}

const mapStateToProps = (state, props) => ({
	user: selectors.getUser(state),
	selected_round: selectors.rounds.getSelectedRound(state, props.selected_round_id),
	actual_round: selectors.rounds.getActualRound(state),
});

export const TopBar = connect(
	mapStateToProps,
)(withRouter(TopBarComponent));

export default TopBar;


// WEBPACK FOOTER //
// ./src/components/TopBar/index.js